import { Contact } from "./Contact";

export interface Email {
    recipient: Contact;
    to: string;
    subject: string;
    body: string;
    attachments: Array<number>;
    photos: Array<number>;
    reference?: number;
    save_type_notification?: Email.ESaveTypeNotification;
    type_notification?: Email.ETypeNotification;
}

export namespace Email {
    export enum ESaveTypeNotification {
        Intervention = "Intervention",
        Audit = "Audit",
        Absence = "Absence",
    }

    export enum ETypeNotification {
        SMS,
        Email,
        DevisRequest,
        InterventionRequest,
        ServiceNote,
        FicheSuiviQualite,
        RapportDeControle,
    }

    export enum EEmailTypes {
        incoming = 1,
        outgoing = 2,
    }
}
